import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;

  & > *:nth-child(2) {
    margin-left: 10px;
  }
`;
